var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":"Informacja","size":"md","backdrop":true,"footer":false},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_vm._v(" Przed zmianą zapisz obecne ustawienia ")])
}
var staticRenderFns = []

export { render, staticRenderFns }